import React, {ReactNode} from 'react';
import PersonalAreaInvoices from './PersonalAreaInvoices';
import Page, {PageType} from '@episerver/spa-core/Page';
import PersonalAreaInvoicesPageData from '../../../Models/Content/PersonalAreaInvoicesPageData';

export default class PersonalAreaInvoicesPage extends Page<PersonalAreaInvoicesPageData> {
  public render(): ReactNode | null {
    return <PersonalAreaInvoices context={this.getContext()} iContent={this.props.data} />;
  }
}
